import { useLotForm, LOT_TYPES, LOT_LANGS, LOT_CONDITIONS } from "@/hooks/publish/useLotForm";
import { usePhotoDropPaste } from "@/hooks/publish/usePhotoDropPaste";
import { MultiPhotoInput } from "@/components/MultiPhotoInput";
import { Input } from "@/components/ui/input";
import { MIN_PHOTOS } from "@/lib/publishQueue";

const Chips = ({ options, value, onChange, testid }) => (
  <div className="flex flex-wrap gap-1.5">
    {options.map((o) => (
      <button key={o.key} type="button" onClick={() => onChange(o.key)} data-testid={`${testid}-${o.key}`}
        className={`h-8 px-3 rounded-full border text-xs ${value === o.key ? "border-[#FF4438] text-white" : "border-[#262626] text-neutral-400"}`}>{o.label}</button>
    ))}
  </div>
);

// P6 · Lote — UI mínima (se rehace con la maqueta); toda la lógica vive en useLotForm.
export const LotFormP6 = ({ game, shippingConfig, onConfigureShip, onPublished }) => {
  const lot = useLotForm({ game, shippingConfig, onPublished });
  const { dragging, dropProps } = usePhotoDropPaste((files) => lot.setPhotos((p) => [...p, ...files].slice(0, 12)));
  const { form, set } = lot;
  return (
    <div className="bg-[#111] border border-[#262626] rounded-md p-4 sm:p-6 mb-6 space-y-4" data-testid="lot-form">
      <div className="font-display text-lg">Tu lote, en 4 datos</div>
      <div className="grid grid-cols-3 gap-2">
        {LOT_TYPES.map((t) => (
          <button key={t.key} type="button" onClick={() => set("subtype", t.key)} data-testid={`lot-type-${t.key}`}
            className={`p-2.5 rounded-md border-2 text-left ${form.subtype === t.key ? "border-[#FF4438]" : "border-[#262626]"}`}>
            <div className="text-sm font-semibold text-white">{t.label}</div><div className="text-[11px] text-neutral-500">{t.hint}</div>
          </button>
        ))}
      </div>
      <Input data-testid="lot-title" placeholder="1 · Título (ej. Bulk 100 comunes Escarlata y Púrpura)" value={form.title} onChange={(e) => set("title", e.target.value.slice(0, 100))} className="bg-[#171717] border-[#262626]" />
      <div className="grid grid-cols-2 gap-2">
        <Input data-testid="lot-approx-cards" type="number" min="1" placeholder="2 · Cartas aprox." value={form.approx_cards} onChange={(e) => set("approx_cards", e.target.value)} className="bg-[#171717] border-[#262626]" />
        <Input data-testid="lot-price" type="number" min="0.25" step="0.01" placeholder="3 · Precio total $" value={form.price} onChange={(e) => set("price", e.target.value)} className="bg-[#171717] border-[#262626]" />
      </div>
      <Chips options={LOT_LANGS} value={form.language} onChange={(v) => set("language", v)} testid="lot-lang" />
      <Chips options={LOT_CONDITIONS} value={form.condition} onChange={(v) => set("condition", v)} testid="lot-cond" />
      <div {...dropProps} className={`rounded-md ${dragging ? "ring-2 ring-[#FF4438]" : ""}`} data-testid="lot-photos-drop">
        <div className="text-xs text-neutral-400 mb-1">4 · Fotos · mín. {MIN_PHOTOS} (arrastra o pega con Ctrl+V)</div>
        <MultiPhotoInput photos={lot.photos} onChange={lot.setPhotos} min={MIN_PHOTOS} max={12} testid="lot-photos" />
      </div>
      {lot.missing.includes("envío") && (
        <button type="button" onClick={onConfigureShip} className="text-xs text-amber-300 underline" data-testid="lot-configure-ship">Configura tu envío</button>
      )}
      {lot.error && <div className="text-xs text-[#FF6B5E]" data-testid="lot-error">{lot.error}</div>}
      <button type="button" disabled={!lot.canSubmit} onClick={lot.submit} data-testid="lot-submit"
        className="w-full h-12 rounded-full bg-[#FF4438] text-white font-bold disabled:opacity-40">{lot.buttonLabel}</button>
      <div className="text-[11px] text-neutral-500 text-center">Los lotes no pasan por el catálogo · se publican al instante</div>
    </div>
  );
};
